export default __webpack_public_path__ + "static/media/header-logo-2.2d595e6d.svg";